import { useEffect, useState } from "react";
import { DCBaseProps } from "./DCBase";
import { AppVibeProcess } from "../vibe-coder/AppVibeProcess";
import { CustomPropertyValue, VibeProcess, Workflow } from "winslow-core";
import toast from "react-hot-toast";
import { toastFail, toastSuccess } from "../../../config";
import { apiGetWorkflow, apiStartVibeProcess, apiGetVibeProcess } from "../../../services/WorkflowService";
import { StartVibeProcessPayload } from "winslow-core";
import { useSelector } from "react-redux";
import { selectEditingCollection, selectUser } from "../../../redux/features/appData/appDataSlice";
import { useNavigate } from "react-router-dom";


type DCVibeProcessProps = DCBaseProps & {
    data: {
        employeeRecordIds: string[] | undefined;
        creatorEmployeeRecordId?: string;
        vibeProcessId?: string;
    }
}

export const DCVibeProcess = ({data, isOutdated, message}: DCVibeProcessProps) => {

    const navigate = useNavigate();

    const storeUser = useSelector(selectUser);
    const editingCollection = useSelector(selectEditingCollection);

    const [workflow, setWorkflow] = useState<Workflow | null>(null);
    const [vibeProcess, setVibeProcess] = useState<VibeProcess | null>(null);
    const [requiredProperties, setRequiredProperties] = useState<string[]>([]);
    const [creatorEmployeeRecordId, setCreatorEmployeeRecordId] = useState<string>(
        data.creatorEmployeeRecordId || storeUser?.employeeRecordId || ""
    );

    useEffect(() => {
        if (message?.content) {
            (async () => {
                const contentObject = JSON.parse(message.content || "{}");
                if (contentObject.workflowId) {
                    const workflow = await apiGetWorkflow(contentObject.workflowId || "");
                    if (workflow) {
                        setWorkflow(workflow);
                    }
                }
            })();
        } 
    }, [message]);

    useEffect(() => {
        if (data.vibeProcessId) {
            (async () => {
                const process = await apiGetVibeProcess(data.vibeProcessId);
                if (process) {
                    setVibeProcess(process);
                    try {
                        const requiredProps = JSON.parse(process.requiredProperties || "[]") as string[];
                        setRequiredProperties(requiredProps);
                    } catch (error) {
                        console.error("Error parsing required properties:", error);
                        setRequiredProperties([]);
                    }
                }
            })();
        }
    }, [data.vibeProcessId]);

    console.log("[DCVibeProcess] isOutdated: ", isOutdated);
    console.log("[DCVibeProcess] data: ", data);
    console.log("[DCVibeProcess] message.content: ", message?.content);

    const handleSubmit = async (propertyValues: Map<string, any>) => {
        console.log("[DCVibeProcess] handleSubmit: ", propertyValues);
        
        // Validate that all required fields are filled
        const missingRequiredFields: string[] = [];
        requiredProperties.forEach(requiredLabel => {
            const value = propertyValues.get(requiredLabel);
            // Check if value is empty, null, undefined, or empty string/array
            if (value === null || value === undefined || value === "" || 
                (Array.isArray(value) && value.length === 0)) {
                // Try to find the display name from vibeProcess
                const property = vibeProcess ? 
                    JSON.parse(vibeProcess.customProperties || "[]").find((p: any) => p.label === requiredLabel) : null;
                const displayName = property?.display || requiredLabel;
                missingRequiredFields.push(displayName);
            }
        });

        if (missingRequiredFields.length > 0) {
            toast(`Please fill in all required fields: ${missingRequiredFields.join(", ")}`, toastFail);
            return;
        }
        
        // NR** make this an AI message so it goes into chat

        const customPropertyValues : CustomPropertyValue[] = [];    
        for (const [key, value] of propertyValues) {
            customPropertyValues.push({ label: key, data: value } as CustomPropertyValue);
        }

        const payload: StartVibeProcessPayload = {
            creatorEmployeeRecordId: creatorEmployeeRecordId || storeUser?.employeeRecordId || "",
            vibeProcessId: data.vibeProcessId,
            propertyValues: JSON.stringify(customPropertyValues),
            userId: storeUser?.id,
            threadId: message?.threadId,
            messageId: message?.id
        }

        toast("Starting workflow...", toastSuccess);

        const result = await apiStartVibeProcess(payload);
       
        if (!result) {
            toast("Failed to start vibe process.", toastFail);
            return;
        }

        navigate(`/waz/chat/${editingCollection?.id}?refresh=true`);
    }

    return (
        <div className="dc-component-card">
            <AppVibeProcess 
                dynamicContext={{ 
                    vibeProcessId: data.vibeProcessId,
                    employeeRecordIds: data.employeeRecordIds,
                    workflow: workflow
                }}
                disabled={isOutdated}
                onSubmit={handleSubmit}
                requiredProperties={requiredProperties}
                creatorEmployeeRecordId={creatorEmployeeRecordId}
                onCreatorEmployeeRecordIdChange={setCreatorEmployeeRecordId}
            />

        </div>
    
    )
}